import { render, staticRenderFns } from "./observatorioDelitos.vue?vue&type=template&id=67a46eaa"
import script from "./observatorioDelitos.vue?vue&type=script&lang=js"
export * from "./observatorioDelitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports